import React, { useRef, useState } from "react";
import {Button, Col, Row} from "react-bootstrap";

import Api from "../utils/Api";
import {sleep} from "../utils/PromiseHelper";

export default function ContactUs()
{
	const textareaElement = useRef(null);
	const nameElement = useRef(null);
	const [state, setState] = useState({sending: false, sent: false});

	const onSubmitForm = async (e) => {
		e.preventDefault();

		setState({sending: true, sent: false});

		// `current` points to the mounted text input element
		await Api.sendContactUs(nameElement.current.value, textareaElement.current.value);
		await sleep(1000); // Make sure it isn't too fast that it's jarring
		setState({sending: false, sent: true});
	};

	return (
		<div className="form-horizontal">
			<div className="form-group">
				<Row className="offset-row">
					<Col md={6} mdOffset={3}>
						<h3>Contact Us</h3>
					</Col>
				</Row>
				<Row className="offset-row">
					<Col md={6} mdOffset={3}>
						<input
							className="form-control"
							type="text"
							placeholder="Name"
							ref={nameElement}
							autoFocus={true}
							disabled={state.sending}
						/>
					</Col>
				</Row>
				<Row className="offset-row">
					<Col md={6} mdOffset={3}>
						<textarea
							className="form-control"
							rows="3"
							placeholder="boring placeholder text..."
							ref={textareaElement}
							disabled={state.sending}
						/>
					</Col>
				</Row>
				<Row className="offset-row">
					<Col md={6} mdOffset={3}>
						<Button
							bsStyle="primary"
							onClick={onSubmitForm}
							disabled={state.sending}
						>
							Submit
						</Button>
					</Col>
				</Row>
				{state.sent &&
					<Row className="offset-row">
						<Col md={6} mdOffset={3}>
							Thank you for contacting us!
						</Col>
					</Row>
				}
			</div>
		</div>
	);
}



// WEBPACK FOOTER //
// ./Components/components/ContactUs.jsx